import { FC, useState } from 'react'
import { Button } from 'react-bootstrap'
import { fetchApi } from '../service'
import { tokenManager } from '../../../../../auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { RunButtonProps } from '../APIManager.d'

const RunButton: FC<RunButtonProps> = ({
    apiUrl,
    setResult,
    disabled = false,
    apiKey = '',
}) => {
    const [isRunning, setIsRunning] = useState<boolean>(false)
    return (
        <Button
            variant="primary"
            className="px-4"
            disabled={disabled || isRunning}
            onClick={() => {
                setIsRunning(true)
                fetchApi('GET', apiUrl, undefined, {
                    Authorization: `Bearer ${tokenManager.getAccessToken()}`,
                    'x-api-key': apiKey,
                })
                    .then((res) => {
                        setResult(res)
                    })
                    .finally(() => setIsRunning(false))
            }}
        >
            {isRunning ? (
                <>
                    <FontAwesomeIcon
                        icon={faCircleNotch}
                        spin
                        className="me-2"
                    />
                    Running
                </>
            ) : (
                'Run'
            )}
        </Button>
    )
}

export default RunButton
